module.exports = __webpack_public_path__ + "media/zapsplat_office_typewriter_carriage_return_vintage_1960_lemair_helvetia_001_40994.2700ccb9.mp3";